import React, { useState, useEffect } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Form, InputPicker, Schema, DatePicker } from 'rsuite';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import { getStates } from '../../../../../services/Shared/codeTable.service'
import Information from '../../../../Shared/Card/Information';
import reinstatementService from '../../../../../services/Internal/Reinstatement/EI/eiReinstatement.service';
import examinationService from '../../../../../services/Internal/Reinstatement/EI/examination.service'
import { GetReinstatementInformationContent } from '../../../../Shared/InformationContent/EiInformation';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import Issues from '../../../../Shared/Card/Issues';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function ExaminationVerification() {
    const [states, setStates] = useState([])
    const routes = useSelector(x => x.currentRoutes);
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const entityId = useSelector(x => x.userInfo.EntityId)
    const sectionId = 17;
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Engineer Intern Reinstatement",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Examination"
        }
    );
    const [formModel, setFormModel] = useState({
        id: 0,
        reinstatementId: reinstatementId,
        entityId: entityId,
        jurisdictionState: null,
        dateOfExam: null,
        userCrte: "",
        dateCrte: new Date(),
        deleted: false
    });
    const [sectionData, setSectionData] = useState({});
    const [hasLoaded, setHasLoaded] = useState(false);
    const push = useNavigate();
    const { DateType, ObjectType } = Schema.Types;
    const model = Schema.Model({
        jurisdictionState: ObjectType().isRequired('This field is required.'),
        dateOfExam: DateType('Please enter a valid date.').isRequired('This field is required.')
    });
    useEffect(() => {
        getStates().then(setStates);
        examinationService.getExamination(reinstatementId).then((response) => {
            if (response.data) {
                setFormModel({
                    ...response.data,
                    dateOfExam: response.data.dateOfExam != null ? new Date(response.data.dateOfExam) : null
                });
            }
            reinstatementService.eiGetSection(reinstatementId, sectionId).then((data) => {
                reinstatementService.getIndividualReinstatement(reinstatementId).then((reinstatementData) => {
                    setIsUserEditable(reinstatementData.data.status.id == 2)
                    entityService.getEntity(data.data.entityId).then((entity) => {
                        setEntityInfo(
                            {
                                ...entityInfo,
                                lolaNum: entity.data.lolaNumber,
                                entityName: entity.data.formattedName,
                                entityId: entity.data.entityId,
                                licenseNumber: reinstatementData.data?.credential?.formattedLicenseNumber,
                                applicationDate: reinstatementData.data?.dateSubmitted,
                                formType: reinstatementData.data?.isOverFiveYears ? "Engineer Intern Reinstatement (5 plus years)" : entityInfo.formType
                            })
                    });
                });
                setSectionData(data.data);
                setIsComplete(data.data.staffReviewComplete)
                setHasLoaded(true);
            })
        })
    }, [])
    const formSubmit = (validation, event) => {
        examinationService.postExamination(formModel).then((response) => {
            reinstatementService.eiMarkSectionComplete(reinstatementId, sectionId, isComplete).then((val) => {
                if (response.data) {
                    nextSectionNavigation();
                }
            })
        })
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
    }
    return (
        <Container fluid>
            <FormEntityInformation {...entityInfo} />
            <Information content={GetReinstatementInformationContent("exam")} />
            <br />
            <Form readOnly={!isUserEditable} fluid model={model} formValue={formModel} onChange={setFormModel} onSubmit={formSubmit}>
                <Card className="mb-3">
                    <Card.Header>
                        Fundamentals Exam (FE)
                    </Card.Header>
                    {hasLoaded ?
                        <Card.Body>
                            <Row className="mb-3">
                                <Col sm={3}>
                                    <Form.ControlLabel>Jurisdiction</Form.ControlLabel>
                                </Col>
                                <Col>
                                    <Form.Control
                                        accepter={InputPicker}
                                        placeholder="Please Select"
                                        block
                                        data={states}
                                        name="jurisdictionState"
                                        searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>Date (mm/dd/yyyy)</Form.ControlLabel>
                                </Col>
                                <Col>
                                    <Form.Control
                                        accepter={DatePicker}
                                        oneTap
                                        format="MM/dd/yyyy"
                                        block
                                        name="dateOfExam"
                                        placeholder=" "
                                    >
                                    </Form.Control>
                                </Col>
                            </Row>
                        </Card.Body>
                        : <LoadingSpinner />
                    }
                </Card>
                <Issues isUserEditable={isUserEditable} isInternal={true} type={2} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                <FormActionButtons
                    isReadOnly={!isUserEditable}
                    nextSectionCallback={nextSectionNavigation}
                    isUserEditable={isUserEditable}
                    isComplete={isComplete}
                    isCompleteCallback={setIsComplete}
                    showSectionComplete={true}
                    backToSectionLink="/internal/eiReinstatement/sections" />
            </Form>
        </Container>
    );
}
export default ExaminationVerification